import React, { useEffect, useState } from 'react';
import API from '../services/api';

// "Card on file" pill for a client-profile header. `endpoint` is the
// card-status URL for the current role, e.g. `/admin/clients/12/card-status`
// or `/therapist/clients/12/card-status`; it answers { hasCard, count,
// unavailable } after checking Authorize.Net.
export default function CardOnFileBadge({ endpoint }) {
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true });
    if (!endpoint) return undefined;
    API.get(endpoint)
      .then((res) => {
        if (cancelled) return;
        const d = res.data || {};
        setState({ loading: false, hasCard: !!d.hasCard, count: d.count || 0, unavailable: !!d.unavailable && !d.hasCard });
      })
      .catch((err) => {
        console.error('Error checking card on file:', err);
        if (!cancelled) setState({ loading: false, error: true });
      });
    return () => { cancelled = true; };
  }, [endpoint]);

  let label, look;
  if (state.loading) {
    label = 'Checking card…';
    look = looks.muted;
  } else if (state.error || state.unavailable) {
    label = 'Card status unavailable';
    look = looks.muted;
  } else if (state.hasCard) {
    label = state.count > 1 ? `💳 ${state.count} cards on file` : '💳 Card on file';
    look = looks.yes;
  } else {
    label = 'No card on file';
    look = looks.no;
  }

  return (
    <span style={{ ...base, ...look }} title="Saved payment card in Authorize.Net">
      {label}
    </span>
  );
}

const base = {
  display: 'inline-block',
  verticalAlign: 'middle',
  padding: '3px 10px',
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1.5,
  whiteSpace: 'nowrap',
  border: '1px solid transparent',
};

const looks = {
  yes: { background: '#E6F4EC', color: 'var(--success-color)', borderColor: '#BFE3CC' },
  no: { background: '#FFF4E5', color: '#9A5B00', borderColor: '#F5D9A8' },
  muted: { background: 'var(--surface-muted)', color: 'var(--text-muted)', borderColor: 'var(--border-color)' },
};
